var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-lk-modal__content "},[_c('h2',{staticClass:"t-lk-modal__title"},[_vm._v(_vm._s(_vm.$root.staticText.lk.leadsReviewBtn))]),_vm._v(" "),_c('form-dynamic-cmp',{staticClass:"t-lk-modal__form t-lk-modal__review",attrs:{"form-info":_vm.form,"button":_vm.props.button,"class-white":false,"action":_vm.infoForm.action,"lead-id":_vm.props.leadId,"personal-data":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/lk-review.vue?vue&type=template&id=b7294ef8&
// module id = 1402
// module chunks = 0